export default __webpack_public_path__ + "images/825746838054cc5d144dd962d57c32f7-musical.jpg";